import React from "react";
import { useIsMobile } from "../hooks/use-is-mobile";
import { cn } from "../lib/utils";

/**
 * Container for a row of TabButtons. Wraps on desktop; on phones it becomes a
 * swipeable, edge-to-edge chip rail.
 */
const TabBar: React.FC<{ className?: string; children: React.ReactNode }> = ({
  className,
  children,
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="-mx-4 w-[calc(100%+2rem)] min-w-0 max-w-none shrink-0 basis-[calc(100%+2rem)] overflow-x-auto overscroll-x-contain [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <div role="tablist" className="flex snap-x gap-2 px-4 py-0.5">
          {children}
        </div>
      </div>
    );
  }

  return <div className={cn("flex flex-wrap items-center gap-2", className)}>{children}</div>;
};

export default TabBar;
